import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import ReactDom from 'react-dom';
import {StyleRoot} from 'radium';
import {push} from 'react-router-redux';
import queryString from 'query-string';

import * as defaultStyles from '../../styles';
import {request} from '../../containers/actions';
import Tree from '../tree';
import {setSelectedItems} from '../tree/actions';
import SchoolSchoolReport from './reports/school_school';
import SchoolClassReport from './reports/school_class';
import SchoolTeacherReport from './reports/school_teacher';
import SchoolGeneralReport from './reports/school_all';
import StudentReport from './reports/student';
import PrintStudentReport from './reports/print_student';
import * as actions from './actions';
import { host_v2 } from '../../utilities/requests';
import { PrintMyContent} from '../../utilities/print';
import ConsolidateReport from './reports/consolidate_report'
import SchoolManagerReport from './reports/school_manager';
import SchoolManagerReportConsolidate from './reports/school_manager_report';
class Report extends React.PureComponent {
    constructor(props) {
        super(props);
    }
    
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    state = {
        currentTab: 0,
        showSchools: false,
        examination: {},
        printData:false
    }


    async componentDidMount() {
        await this.context.store.dispatch(setSelectedItems(
            [],
            'school',
            this.props.store.getIn(['schoolsTree', 'elementId']),
        ));
        await this.fetch.bind(this)();
        await this.fetchFilters()

        if(this.context.user?.type?.at(0) === 'teacher')
            this.setState(e=>({...e, currentTab: 3}))
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.store.getIn(['regionsTree', 'selected']).keySeq().first() !==
            this.props.store.getIn(['regionsTree', 'selected']).keySeq().first()
        ) {
            this.context.store.dispatch(setSelectedItems(
                [],
                'city',
                this.props.store.getIn(['citiesTree', 'elementId']),
            ));
        }
        else if (
            nextProps.store.getIn(['citiesTree', 'selected']).keySeq().first() !==
            this.props.store.getIn(['citiesTree', 'selected']).keySeq().first()
        ) {
            this.context.store.dispatch(setSelectedItems(
                [],
                'school',
                this.props.store.getIn(['schoolsTree', 'elementId']),
            ));
        }
        if (nextProps.params.examinationId !== this.props.params.examinationId) {
            this.context.store.dispatch(setSelectedItems(
                [],
                'school',
                this.props.store.getIn(['schoolsTree', 'elementId']),
            ));
        }

        if (
            nextProps.store.getIn(['general', 'regionsTreeFilter', 'selected']) !==
            this.props.store.getIn(['general', 'regionsTreeFilter', 'selected']) &&
            nextProps.store.getIn(['general', 'regionsTreeFilter', 'selected']).size === 1
        ) {
            this.context.store.dispatch(setSelectedItems(
                nextProps.store.getIn(['general', 'regionsTreeFilter', 'selected']).keySeq().toArray(),
                'region',
                this.props.store.getIn(['regionsTree', 'elementId']),
            ));
        }
        if (
            nextProps.store.getIn(['general', 'citiesTreeFilter', 'selected']) !==
            this.props.store.getIn(['general', 'citiesTreeFilter', 'selected']) &&
            nextProps.store.getIn(['general', 'citiesTreeFilter', 'selected']).size === 1 &&
            nextProps.store.getIn(['general', 'regionsTreeFilter', 'selected']).size === 1
        ) {
            this.context.store.dispatch(setSelectedItems(
                nextProps.store.getIn(['general', 'regionsTreeFilter', 'selected']).keySeq().toArray(),
                'region',
                this.props.store.getIn(['regionsTree', 'elementId']),
            ));
            this.context.store.dispatch(setSelectedItems(
                nextProps.store.getIn(['general', 'citiesTreeFilter', 'selected']).keySeq().toArray(),
                'city',
                this.props.store.getIn(['citiesTree', 'elementId']),
            ));
        }
        if (
            nextProps.store.getIn(['general', 'schoolsTreeFilter', 'selected']) !==
            this.props.store.getIn(['general', 'schoolsTreeFilter', 'selected']) &&
            nextProps.store.getIn(['general', 'schoolsTreeFilter', 'selected']).size === 1 &&
            nextProps.store.getIn(['general', 'citiesTreeFilter', 'selected']).size === 1 &&
            nextProps.store.getIn(['general', 'regionsTreeFilter', 'selected']).size === 1
        ) {
            this.context.store.dispatch(setSelectedItems(
                nextProps.store.getIn(['general', 'regionsTreeFilter', 'selected']).keySeq().toArray(),
                'region',
                this.props.store.getIn(['regionsTree', 'elementId']),
            ));
            this.context.store.dispatch(setSelectedItems(
                nextProps.store.getIn(['general', 'citiesTreeFilter', 'selected']).keySeq().toArray(),
                'city',
                this.props.store.getIn(['citiesTree', 'elementId']),
            ));
            this.context.store.dispatch(setSelectedItems(
                nextProps.store.getIn(['general', 'schoolsTreeFilter', 'selected']).keySeq().toArray(),
                'school',
                this.props.store.getIn(['schoolsTree', 'elementId']),
            ));
        }
    }

    async fetchFilters(){
     if(this.context.user.hasPerm('admin')){
     }else{
        const url = host_v2 + '/api/ClientApi/GetClientSchoolsInExam?examId=' + this.props.params.examinationId;
        var token = this.context.store.getState().get('application').get('token'); 
        var auth = token.get('accessToken');
        const response = await fetch(url, {
            headers: {
                Authorization: auth
            }
        });

        const data = await response.json();

        if(!data?.errorId ){
            let arr = [];
            data.result.map(el=>arr.push(el.id))
            this.context.store.dispatch(setSelectedItems(
                arr,
                'school',
                this.props.store.getIn(['general', 'schoolsTreeFilter', 'elementId']),
            ));
        }
     }
    }

    async fetch() {
        this.context.store.dispatch(actions.setExamination(
            {},
            this.props.store.getIn(['main', 'elementId']),
        ));

        let url = `/examination/${this.props.params.examinationId}/?detailed&report&react__route=${window.location.pathname}`;
        const response = await this.context.store.dispatch(request(url));
        this.setState({examination: response});
    }

    cityItemLabel(city) {
        return `${city.region_display} - ${city.name}`;
    }

    schoolItemLabel(school) {
        return `${school.city.name} - ${school.name} - ` +
            `${_.map(school.levels, level => level.title).join(window.gettext(',') + ' ')}`;
    }
    getExamType(){
        try {
            
            var type = this.state.examination.examination_type.id;
            return type;
            
        } catch (e) {
            return 0;
        }
    }
 
    async getAllData(){
        debugger;
        const win = this.refs.print.contentWindow;
        
        var examId = this.state.examination.id;
        var regionId = this.props.store.getIn(['regionsTree','selected']).keySeq().first();
        var lastItem = JSON.parse(localStorage.getItem('printSchools'));
        if(lastItem === null || lastItem == undefined){
            lastItem = {
                id : 0,
                title : "",
                exam : examId
            }
        } 
        var startFrom = 0;
        if(lastItem.id > 5){
            var itemText = "دریافت خروجی از ادامه قبلی ها انجام شود ؟";
            if(win.confirm(itemText)){
                lastItem.id = lastItem.id - 5;
                startFrom = lastItem.id;
            } 
        }

        let urlGetCities = `/city/?limit=100000&multiple_choice_papers_examinations=${examId}&region=${regionId}`;
        var citiesInRegionApiResult = await this.context.store.dispatch(request(urlGetCities));
        var citiesInRegion = citiesInRegionApiResult.results;
        
        // this.setState({printing: true});
        ReactDom.unmountComponentAtNode(win.document.getElementById('content'));
        win.document.getElementById('content').innerHTML = '';
        for (var i = 0; i < citiesInRegion.length; i++) {
            let urlGetSchools = `/school/?city=${citiesInRegion[i].id}&limit=100000&students__student__multiple_choice_papers__examination=${examId}`;
            var schoolsInCityApiResult = await this.context.store.dispatch(request(urlGetSchools));
            var schoolsInCity = schoolsInCityApiResult.results;
            for (var j = 0; j < schoolsInCity.length; j++) { 
                if(startFrom !=0){
                    startFrom --;
                    continue;
                }
                
                lastItem.id +=1;
                lastItem.title = schoolsInCity[j].name; 
                localStorage.setItem('printSchools', JSON.stringify(lastItem));

                var school = schoolsInCity[j].id;
                var data = await this.context.store.dispatch(request({
                    path: `/examination/${examId}/report/school_student/`,
                    body: { school },
                }));
                var imageCounter = 0;
                var counter = 0;
                debugger;
                ReactDom.render(<StyleRoot>
                    {_.map(data.students, (row, id) => ++counter && <PrintStudentReport
                        key={id}
                        first={counter === 1}
                        last={counter === _.size(data.students)}
                        imageLoaded={() => {
                            imageCounter++;
                            console.log('imageCounter', imageCounter);
                            if (imageCounter === _.size(data.students)) {
                                var htmlContent = win.document.getElementById('content').innerHTML;
                                console.log('htmlContent', htmlContent);
                                win.print();
                            }
                        }}
                        data={{ ...row, ...data.info }}
                        examination={this.state.examination}
                    />)}
                </StyleRoot>, win.document.getElementById('content'));
            }
        } 
    }
    
    render() {  
        
        var type = this.getExamType();
        // if(this.context!==null && this.context.user!=null && this.context.user.type[0] === "student" && type === 6 && (this.context.user.cell_phone === null || String(this.context.user.cell_phone).length<5 ||this.context.user.cell_phone_verified ===false))//
        // { 
        //     return <span>
        //         <div>دانش آموز عزیز، لطفا جهت دریافت کارنامه، شماره تلفن همراه خود را ثبت و تایید نمایید.</div>   
        //         <div style={{width:300,margin:'auto'}}> 
        //             <button
        //                 key='close'
        //                 style={{
        //                     ...defaultStyles.button,
        //                     float: 'left',
        //                     marginRight: '.5em',
        //                 }}
        //                 onClick={() => this.context.store.dispatch(push(this.props.urls.back.format(this.props.params)))}>
        //                 {window.gettext('Back')}
        //             </button>
        //             <button
        //                 style={{
        //                     ...defaultStyles.defaultButton,
        //                     float: 'left',
        //                     marginRight: '.5em'
        //                 }}
        //                 onClick={() => this.context.store.dispatch(push('/profile/?2'))}>
        //                 ثبت شماره‌ی تلفن همراه
        //             </button>
        //         </div>
        //     </span>;
        // }
        if (!this.state.examination.id || this.state.examination.id.toString() !== this.props.params.examinationId)
            return null;
        if (this.props.children)
            return this.props.children;
        if (this.props.module === 'student' && this.context.user?.type?.at(0) !== 'teacher') {
            return <StudentReport
                autoRefresh={this.props.autoRefresh}
                urls={this.props.urls}
                params={this.props.params}
                examination={this.state.examination}
                student={this.props.params.studentId}
            />;
        }
        let school;
        if (this.props.params.schoolId)
            school = this.props.params.schoolId;

        else {
            school = this.props.store.getIn(['schoolsTree', 'selected']).keySeq().first();
            let items = this.context.store.getState().getIn(['trees', 'items', 'school:' + queryString.stringify({
                limit: 100000,
                students__student__multiple_choice_papers__examination: this.state.examination.id,
            })]);
            if (this.context.user.is('manager') && items && items.size)
                school = items.valueSeq().first().get('id');
        }


        return <div>
            {this.context.pending
                ? null
                : this.context.user?.type?.at(0) !== 'teacher' && <div style={{position: 'relative'}}>
                    <div
                        style={{
                            position: 'absolute',
                            right: '60%',
                            transform: 'translateX(50%)',
                            fontWeight: '500',
                            fontSize: '1.4em',
                        }}>
                        {this.state.examination.title}
                    </div>
                    <button
                        style={
                            this.state.currentTab === 0
                                ? defaultStyles.activeTabButton
                                : defaultStyles.tabButton
                        }
                        onClick={() => this.setState({currentTab: 0})}>
                        {window.gettext('Manager Report')}
                    </button>
                    <button
                        style={
                            this.state.currentTab === 1
                                ? defaultStyles.activeTabButton
                                : defaultStyles.tabButton
                        }
                        onClick={() => this.setState({currentTab: 1})}>
                        {window.gettext('School Report')}
                    </button>
                    <button
                        style={
                            this.state.currentTab === 2
                                ? defaultStyles.activeTabButton
                                : defaultStyles.tabButton
                        }
                        onClick={() => this.setState({currentTab: 2})}>
                        {window.gettext('Class Report')}
                    </button>
                    <button
                        style={
                            this.state.currentTab === 3
                                ? defaultStyles.activeTabButton
                                : defaultStyles.tabButton
                        }
                        onClick={() => this.setState({currentTab: 3})}>
                        {window.gettext('Teacher Report')}
                    </button>
                    {this.context.user.is('admin') || this.context.user.hasPerm('client.show_pubreport')
                        ? <button
                            style={
                                this.state.currentTab === 4
                                    ? defaultStyles.activeTabButton
                                    : defaultStyles.tabButton
                            }
                            onClick={() => this.setState({currentTab: 4})}>
                            {window.gettext('General Report')}
                        </button>
                        : null
                    }
                    {this.props.urls && this.props.urls.back
                        ? <button
                            key='close'
                            style={{
                                ...defaultStyles.button,
                                float: 'left',
                                marginRight: '.5em',
                            }}
                            onClick={() => this.context.store.dispatch(push(this.props.urls.back.format(this.props.params)))}>
                            {window.gettext('Back')}
                        </button>
                        : null
                    }
                    {(this.context.user.is('admin') || this.context.user.hasPerm('client.show_pubreport')) && 
                    (this.state.examination.isconsolidated)
                        ? <button
                            style={
                                this.state.currentTab === 5
                                    ? defaultStyles.activeTabButton
                                    : defaultStyles.tabButton
                            }
                            onClick={() => this.setState({ currentTab: 5 })}>
                            {window.gettext('کارنامه تلفیقی')}
                        </button>
                        : null
                    }
                    <div style={{height:"0" , overflow:"hidden"}}>
                        <iframe
                            ref='print'
                            style={{width: '0', height: '0', border: 'none'}}
                            srcDoc={`<html>
                                        <head>
                                            <link rel="stylesheet" type="text/css" href="/css/mhelli.css">
                                            <style>
                                                @page {
                                                    size: A4 Portrait;
                                                    margin: 0;
                                                }
                                                body {
                                                    background-color: white;
                                                }
                                            </style>
                                        </head>
                                        <body dir='rtl'>
                                            <span id='content'>
                                                <span>1</span><span style='font-weight: 700;'>2</span>
                                            </span>
                                        </body>
                                    </html>`}
                        />
                    </div>
                    {this.state.printing
                        ? <i className='fa-spin fa-spinner fa-2x'></i>
                        : school
                            ? <button
                                key='print'
                                style={{
                                    ...defaultStyles.defaultButton,
                                    float: 'left',
                                    marginRight: '.5em',
                                }}
                                onClick={     
                                    async () => {
                                        this.setState({printing: true});
                                        const data = await this.context.store.dispatch(request({
                                            path: `/examination/${this.state.examination.id}/report/school_student/`,
                                            body: {school},
                                        }));
                                        
                                        const win = this.refs.print.contentWindow;
                                        let imageCounter = 0;
                                        win.document.getElementById('content').innerHTML = '';
                                        
                                        let counter = 0;
                                        ReactDom.render(<StyleRoot>
                                            {_.map(data.students, (row, id) => ++counter && <PrintStudentReport
                                                key={id}
                                                first={counter === 1}
                                                last={counter === _.size(data.students)}
                                                imageLoaded={() => {
                                                    imageCounter++;
                                                    if (imageCounter === _.size(data.students)) {
                                                        // win.print();
                                                        PrintMyContent(this.refs.print ,()=>{this.setState({printing: false})},20,2,999999999,`${this.state.examination.title}-${this.state.examination.grades[0].title}`);
                                                    }
                                                }}
                                                data={{...row, ...data.info}}
                                                examination={this.state.examination}
                                            />)}
                                        </StyleRoot>, win.document.getElementById('content'));
                                    }}>
                                {window.gettext('Print Students Reports')}
                            </button>
                            : <button
                            key='printAllSchoolInProvince'
                            style={{
                                ...defaultStyles.defaultButton,
                                float: 'left',
                                marginRight: '.5em',
                            }}
                            onClick={()=>this.getAllData()}>
                            {window.gettext('Print Students Reports New')}
                        </button>
                    }
                    {/* <button
                                key='printAllSchoolInProvince'
                                style={{
                                    ...defaultStyles.defaultButton,
                                    float: 'left',
                                    marginRight: '.5em',
                                }}
                                onClick={()=>this.getAllData()}>
                                {window.gettext('Print Students Reports New')}
                            </button> */}
                </div>
            }
            <div
                style={{
                    marginTop: '.5em',
                    display: this.props.params.schoolId || this.context.user.is('manager') ? 'none' : 'inline-block',
                    width: '100%',
                }}>
                {this.context.user?.type?.at(0) !== 'teacher' && this.state.examination.id && this.state.currentTab !== 4
                &&this.state.currentTab !== 5 
                    ? [
                        <div key='region' style={treeStyle}>
                            <Tree
                                store={this.props.store.get('regionsTree')}
                                readonly
                                resource='region'
                                itemLabel='name'
                                multiSelection={false}
                                combobox
                                label={window.gettext('Region')}
                                filter={{multiple_choice_papers_examinations: this.state.examination.id}}
                            />
                        </div>,
                        <div key='city' style={treeStyle}>
                            <Tree
                                store={this.props.store.get('citiesTree')}
                                readonly
                                resource='city'
                                itemLabel={this.cityItemLabel}
                                multiSelection={false}
                                combobox
                                label={window.gettext('City')}
                                filter={{
                                    region: this.props.store.getIn(['regionsTree', 'selected']).keySeq().join(',') || '-1',
                                    multiple_choice_papers_examinations: this.state.examination.id,
                                }}
                            />
                        </div>,
                        <div key='school' style={{...treeStyle, width: '35%'}}>
                            <Tree
                                store={this.props.store.get('schoolsTree')}
                                readonly
                                resource='school'
                                itemLabel={this.schoolItemLabel}
                                multiSelection={false}
                                combobox
                                label={window.gettext('School')}
                                filter={{
                                    city: this.props.store.getIn(['citiesTree', 'selected']).keySeq().join(',') || (
                                        this.context.user.is('manager') ? undefined : '-1'
                                    ),
                                    students__student__multiple_choice_papers__examination: this.state.examination.id,
                                }}
                            />
                        </div>,
                    ]
                    : null
                }
            </div> 
            {(this.state.currentTab === 0 && this.state.examination.isconsolidated)
                ? <SchoolManagerReportConsolidate
                    store={this.props.store.get("general")}
                    urls={this.props.urls}
                    params={this.props.params}
                    examination={this.state.examination}
                    examinationStudents={this.props.store.get('examinationStudents')}
                    school={school}
            />
                :
                this.state.currentTab === 0
                ? <SchoolManagerReport
                    store={this.props.store.get("general")}
                    urls={this.props.urls}
                    params={this.props.params}
                    examination={this.state.examination}
                    examinationStudents={this.props.store.get('examinationStudents')}
                    school={school}
                />
                :
                 this.state.currentTab === 1
                    ? <SchoolSchoolReport
                        urls={this.props.urls}
                        params={this.props.params}
                        examination={this.state.examination}
                        school={school}
                    />
                    : this.state.currentTab === 2
                        ? <SchoolClassReport
                            urls={this.props.urls}
                            params={this.props.params}
                            examination={this.state.examination}
                            school={school}
                        />
                        : this.state.currentTab === 3
                            ? <SchoolTeacherReport
                                urls={this.props.urls}
                                params={this.props.params}
                                examination={this.state.examination}
                                school={school}
                                user={this.context.user}
                            />
                            : this.state.currentTab === 4
                                ? <SchoolGeneralReport
                                    urls={this.props.urls}
                                    params={this.props.params}
                                    examination={this.state.examination}
                                    store={this.props.store.get('general')}
                                    
                                />
                                : (this.state.currentTab === 5 && this.state.examination.isconsolidated)
                                ? <ConsolidateReport
                                    store={this.props.store.get("general")}
                                    urls={this.props.urls}
                                    params={this.props.params}
                                    examination={this.state.examination}
                                />
                                : null
            }
        </div>;
    }
}

const treeStyle = {
    fontSize: '.8em',
    width: 'calc(25% - 1em)',
    marginBottom: '1em',
    marginLeft: '.5em',
    marginRight: '.5em',
    float: 'right',
    maxHeight: '25em',
};


export default class Wrapper extends React.PureComponent {
    render() {
        this.params = _.isEqual(this.params, this.props.params) ? this.params : this.props.params;
        return <Report {..._.pickBy(this.props, (__, prop) => !_.includes(['location', 'routes', 'routeParams'], prop))} params={this.params}/>;
    }
}

